module.exports = __webpack_public_path__ + "img/Delete - Medium Gray - Selected.ede0cb02.png";